<script lang="ts">
  import type { NoteName } from 'shared/definitions/musicTheory/notesAndAccidentals';
  import { createEventDispatcher } from 'svelte';
  import { uniqueFilter } from 'shared/src/utils/uniqueFilter';
  import MidiInput from '../../uTheory.Notation/midiInput';
  import PianoSvgComponent from './PianoSVGComponent.svelte';
  import type Note from '../../uTheory.Notation/note';

  export let isInteractive = true;
  export let isMidiInteractive = true;

  export let lowestNote: NoteName | Note | undefined = undefined;
  export let highestNote: NoteName | Note | undefined = undefined;

  export let height = 200;

  export let activeMidis: number[] = [];

  const dispatch = createEventDispatcher<{
    noteOn: {
      midiNumber: number;
      velocity?: number;
      activeMidis: number[];
    };
    noteOff: {
      midiNumber: number;
      activeMidis: number[];
    };
    change: {
      activeMidis: number[];
    };
  }>();

  const midiInput = new MidiInput(typeof window === 'undefined');
  if (typeof window !== 'undefined') {
    midiInput.init();
  }

  let pianoSVG: PianoSvgComponent | undefined;

  let manuallyPressedNotes: number[] = [];

  $: activeMidis = [...$midiInput.sounding.map((m) => m.midi), ...manuallyPressedNotes].filter(
    uniqueFilter,
  );

  $: {
    $midiInput.added.forEach(({ midi, velocity }) => {
      if (!isMidiInteractive) return;
      dispatch('noteOn', { midiNumber: midi, velocity, activeMidis });
      dispatch('change', { activeMidis });
    });
    $midiInput.removed.forEach(({ midi }) => {
      if (!isMidiInteractive) return;
      // Turn the sound off
      dispatch('noteOff', { midiNumber: midi, activeMidis });
      dispatch('change', { activeMidis });
      // Remove from pianoSVG
      pianoSVG?.removeNote(midi);
    });
  }

  export function allNotesOff() {
    manuallyPressedNotes = [];
    midiInput.panic();
    pianoSVG?.clear();
  }
</script>

<PianoSvgComponent
  bind:this={pianoSVG}
  {isInteractive}
  isMidiInteractive={false}
  {highestNote}
  {lowestNote}
  {height}
  on:noteOn={(info) => {
    manuallyPressedNotes = [...manuallyPressedNotes, info.detail.midiNumber].filter(uniqueFilter);
    activeMidis = [...$midiInput.sounding.map((m) => m.midi), ...manuallyPressedNotes].filter(
      uniqueFilter,
    );
    dispatch('noteOn', { midiNumber: info.detail.midiNumber, activeMidis });
    dispatch('change', { activeMidis });
  }}
  on:noteOff={(info) => {
    manuallyPressedNotes = manuallyPressedNotes.filter((m) => m !== info.detail.midiNumber);
    activeMidis = [...$midiInput.sounding.map((m) => m.midi), ...manuallyPressedNotes].filter(
      uniqueFilter,
    );
    dispatch('noteOff', { midiNumber: info.detail.midiNumber, activeMidis });
    dispatch('change', { activeMidis });
  }}
  sticky
  otherHighlightedMidis={$midiInput.sounding.map((e) => e.midi)}
/>
